// https://stackoverflow.com/a/47593316
function cyrb128(str: string): number[] {
    let h1 = 1779033703, h2 = 3144134277,
        h3 = 1013904242, h4 = 2773480762;
    for (let i = 0, k; i < str.length; i++) {
        k = str.charCodeAt(i);
        h1 = h2 ^ Math.imul(h1 ^ k, 597399067);
        h2 = h3 ^ Math.imul(h2 ^ k, 2869860233);
        h3 = h4 ^ Math.imul(h3 ^ k, 951274213);
        h4 = h1 ^ Math.imul(h4 ^ k, 2716044179);
    }
    h1 = Math.imul(h3 ^ (h1 >>> 18), 597399067);
    h2 = Math.imul(h4 ^ (h2 >>> 22), 2869860233);
    h3 = Math.imul(h1 ^ (h3 >>> 17), 951274213);
    h4 = Math.imul(h2 ^ (h4 >>> 19), 2716044179);
    return [(h1^h2^h3^h4)>>>0, (h2^h1)>>>0, (h3^h1)>>>0, (h4^h1)>>>0];  // 128-bit hash
}

function mulberry32(a: number): () => number {
    return function () {
        let t = a += 0x6D2B79F5;
        // eslint-disable-next-line
        t = Math.imul(t ^ t >>> 15, t | 1);
        // eslint-disable-next-line
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        // eslint-disable-next-line
        return ((t ^ t >>> 14) >>> 0) / 4294967296;                     // Random [0, 1)
    }
}

export default class RandomGenerator {

    private readonly generator: () => number;

    constructor(seed: string) {
        this.generator = mulberry32(cyrb128(seed)[0]);
    }

    public next(): number {
        return this.generator();
    }

}